import React from 'react';
export var composableComponentFactory = function (forwardRefFn, displayName, childComponents) {
    var comp = React.forwardRef(forwardRefFn);
    comp.displayName = displayName;
    var combined = Object.assign(comp, childComponents);
    return combined;
};
//# sourceMappingURL=composableComponentFactory.js.map